import React from "react";
import { Eye } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { FIVE_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createPreview, createPreviewVersion, getPreviews, updatePreviewMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-009: Preview Text authoring (PRV-SPEC-001).
const config = {
  familyCode: "PRV",
  testIdPrefix: "previews",
  idField: "preview_id",
  contentField: "canonical_preview",
  contentLabel: "Canonical Preview",
  contentInputType: "text",
  contentPlaceholder: "e.g. See if you qualify in under 2 minutes.",
  labelSingular: "Preview Text",
  labelPlural: "Preview Text",
  icon: Eye,
  statusValues: FIVE_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable inbox preview snippet (PRV####).",
  api: {
    list: getPreviews,
    create: ({ name, status, content }) => createPreview({ name, status, canonicalPreview: content }),
    createVersion: (id, { version, content }) => createPreviewVersion(id, { version, canonicalPreview: content }),
    updateMetadata: (id, { name, status }) => updatePreviewMetadata(id, { name, status }),
  },
};

export default function PreviewsPanel() {
  return <AssetFamilyPanel config={config} />;
}
